"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Avatar = _interopRequireDefault(require("../Avatar"));
var _ManagerStatus = _interopRequireDefault(require("../ManagerStatus"));
var _Name = _interopRequireDefault(require("../Name"));
var Manager = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _ref$avatarUrl = _ref.avatarUrl,
    avatarUrl = _ref$avatarUrl === void 0 ? '' : _ref$avatarUrl,
    name = _ref.name,
    _ref$phone = _ref.phone,
    phone = _ref$phone === void 0 ? null : _ref$phone,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? null : _ref$status,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_react["default"].createElement(StyledManager, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
    name: name,
    url: avatarUrl
  }), /*#__PURE__*/_react["default"].createElement(StyledName, {
    name: name
  }), phone && /*#__PURE__*/_react["default"].createElement(StyledPhone, null, phone), status && /*#__PURE__*/_react["default"].createElement(StyledStatus, {
    status: status
  }));
});
Manager.displayName = 'Manager';
var StyledManager = _styledComponents["default"].div.withConfig({
  displayName: "Manager__StyledManager",
  componentId: "sc-d5kcvo-0"
})(["align-items:center;color:#4d4d4d;display:flex;font-size:14px;"]);
var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "Manager__StyledAvatar",
  componentId: "sc-d5kcvo-1"
})(["height:26px;width:26px;"]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "Manager__StyledName",
  componentId: "sc-d5kcvo-2"
})(["font-weight:normal;", " + &{margin-left:10px;}"], StyledAvatar);
var StyledPhone = _styledComponents["default"].div.withConfig({
  displayName: "Manager__StyledPhone",
  componentId: "sc-d5kcvo-3"
})([":before{content:'\u22C5';margin:0 4px;}"]);
var StyledStatus = (0, _styledComponents["default"])(_ManagerStatus["default"]).withConfig({
  displayName: "Manager__StyledStatus",
  componentId: "sc-d5kcvo-4"
})(["margin-left:10px;"]);
var _default = exports["default"] = Manager;